var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showToast)?_c('div',{staticClass:"toast"},[_c('span',[_vm._v(_vm._s(_vm.msg))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }